// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2026-05-27 14:18:05 +0200 (Wed, 27 May 2026) $
// Author      : Ulrich Mierendorff
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 163319 $
// Purpose     : Database Administration and Debugging Parts
// =============================================================================
import { treeAspect, isRootDomainConfig, isDomainRecord } from 'uix/views/utils';
export const database = {
    ...treeAspect,
    tabGroup: 'database',
    acl: 'g:debug',
    cfg: isRootDomainConfig,
    enabled: isDomainRecord,
    tabs: {
        start: {
            default: true,
            tabGroupDefault: true,
            parts: [
                'DatabaseDashboard'
            ]
        },
        cmd: {
            parts: [
                'DatabaseCommand'
            ]
        },
        stats: {
            parts: [
                'DatabaseTableStats'
            ]
        },
        index: {
            parts: [
                'DatabaseIndexes'
            ]
        },
        activities: {
            parts: [
                'DatabaseActivities'
            ]
        },
        schema: {
            parts: [
                'DatabaseSchema'
            ]
        },
        backup: {
            parts: [
                'DatabaseBackup'
            ]
        },
        updates: {
            parts: [
                'DatabaseUpdates'
            ]
        }
    }
};
